module.exports = __webpack_public_path__ + "img/aed-behance.db357938.jpg";